import { clsx } from 'clsx';
import React from 'react';
import { Clearance } from '../../../../../js/api';

import { StatusPill } from '../../../components/StatusPill';

import { WorkflowScopes } from '../../../constants/workflows';
import { formatApiDate, getDateTemporalityClass } from '../../../utils/date';

const CardHeading: React.FC<React.ComponentPropsWithoutRef<'p'>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <p
      {...props}
      className={clsx(
        className,
        'tw:!text-[16px] tw:font-semibold tw:text-zinc-900 tw:dark:text-zinc-100 tw:!mb-0'
      )}
    >
      {children}
    </p>
  );
};

export const ClearanceCard: React.FC<{
  clearance: Clearance;
  isSelected?: boolean;
}> = ({ clearance, isSelected = false }) => {
  // Determine styling for next review date based on temporality (reusable utility)
  const nextReviewClass = getDateTemporalityClass(clearance.next_review_on);

  return (
    <div
      className={clsx(
        'tw:h-full tw:bg-white tw:rounded-lg tw:shadow-sm tw:border tw:border-zinc-200 tw:border-l-zinc-300 tw:border-l-6 tw:hover:shadow-md tw:hover:bg-muted tw:transition-shadow tw:cursor-pointer',
        isSelected && 'tw:!bg-brand-green-0/10 tw:!shadow-md'
      )}
    >
      <div className="tw:p-3">
        <div className="tw:flex tw:justify-between tw:items-start tw:mb-3">
          <CardHeading className="tw:line-clamp-2">
            <i className="far fa-fw fa-lg fa-check-double tw:mr-1" />
          </CardHeading>
          <div className="tw:flex tw:items-center tw:gap-2">
            <StatusPill
              scope={WorkflowScopes.Clearance}
              status={clearance.current_status || 'Unknown'}
            />
          </div>
        </div>
        <div className="tw:lg:text-lg tw:font-medium">{clearance.provider.display_name}</div>
        {clearance.next_review_on && (
          <div className="tw:flex tw:items-center tw:gap-2 tw:mb-1">
            <i className="far fa-fw fa-calendar tw:text-zinc-400 tw:dark:text-zinc-500" />
            <span className={nextReviewClass}>
              {formatApiDate(clearance.next_review_on, {
                prefix: 'Next Review',
                emptyLabel: 'No Review Date',
              })}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClearanceCard;
